/**************************************************************************************************/
/*   File: /src/app/stores/selectors/details/selectors.ts                                          */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Apr 19 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducers from '../../reducers/details';
import * as fromStates from '../../states/details';
import { DossierContent } from '../../../shared/models';

/**
 * Get the dossier creation State
 */
export const getDossierDetailsState = createFeatureSelector<fromStates.DetailsState>('details');

/**
 * Get is loading
 */
export const getIsLoading = createSelector(
    getDossierDetailsState,
    fromReducers.helpers.getIsLoading
);
/**
 * Get messages
 */
export const getMessages = createSelector(
    getDossierDetailsState,
    fromReducers.helpers.getMessages
);
/**
 * Get is validating
 */
export const getIsValidating = createSelector(
    getDossierDetailsState,
    fromReducers.helpers.getIsValidating
);
/**
 * Get is validated
 */
export const getIsValidated = createSelector(
    getDossierDetailsState,
    fromReducers.helpers.getIsValidated
);
/**
 * Get is loaded
 */
export const getIsLoaded = createSelector(
    getDossierDetailsState,
    fromReducers.helpers.getIsLoaded
);
/**
 * Get dossier
 */
export const getDossier = createSelector(
    getDossierDetailsState,
    fromReducers.helpers.getDossier
);


export const getDossierPublic = createSelector(
    getDossierDetailsState,
    fromReducers.helpers.getDossierPublic
);

/**
 * Get the current dossier id
 */
export const getDossierId = createSelector(
    getDossierDetailsState,
    fromReducers.helpers.getDossierId
);
/**
 * Get dossier status
 */
export const getDossierStatus = createSelector(
    getDossierDetailsState,
    fromReducers.helpers.getDossierStatus
);

/**
 * Is set plan code
 */
export const isSetPlanCode = createSelector(
    getDossier,
    (dossier) => {
        return dossier !== undefined &&
            dossier.summary !== undefined &&
            dossier.summary.plan !== undefined &&
            dossier.summary.plan.code !== undefined;
    }
);
/**
 * Is get Selected plan 
 */
export const getSelectedPlan = createSelector(
    getDossier,
    (dossier) => {
        return dossier !== undefined &&
            dossier.summary !== undefined &&
            dossier.summary.plan !== undefined ? dossier.summary.plan : undefined;
    }
);
/**
 * Is set ambito code
 */
export const isSetAmbitoCode = createSelector(
    getDossier,
    (dossier) => {
        return dossier !== undefined &&
            dossier.summary !== undefined &&
            dossier.summary.territorialAreas !== undefined &&
            dossier.summary.territorialAreas.length > 0;
    }
);
/**
 * Is getAmbitiCodes 
 */
export const getAmbitiCodes = createSelector(
    getDossier,
    (dossier) => {
        return dossier !== undefined &&
            dossier.summary !== undefined &&
            dossier.summary.territorialAreas !== undefined &&
            dossier.summary.territorialAreas.length > 0 ? dossier.summary.territorialAreas : [];
    }
);
/**
 * Is set spatial data type
 */
export const isSetSpatialDataType = createSelector(
    getDossier,
    (dossier) => {
        return dossier !== undefined &&
            dossier.spatialData !== undefined &&
            dossier.spatialData.spatialDataType !== undefined;
    }
);
/**
 * Get the spatial data
 */
export const getSpatialData = createSelector(
    getDossier,
    (dossier) => {
        return dossier !== undefined &&
            dossier.spatialData !== undefined ? dossier.spatialData : undefined;
    }
);
/**
 * Get the spatial data
 */
export const getSpatialDataReport = createSelector(
    getDossier,
    (dossier) => {
        return dossier !== undefined &&
            dossier.spatialDataReport !== undefined ? dossier.spatialDataReport : undefined;
    }
);
/**
 * Get the spatial informative report
 */
export const getSpatialInformativeReport = createSelector(
    getDossier,
    (dossier) => {
        return dossier !== undefined &&
            dossier.spatialInformativeReport !== undefined ? dossier.spatialInformativeReport : undefined;
    }
);
/**
 * Get the other data
 */
export const getOtherDataFile = createSelector(
    getDossier,
    (dossier) => {
        return dossier !== undefined &&
            dossier.other !== undefined ? dossier.other : undefined;
    }
);
/**
 * Get the other data
 */
export const getTerritorialAreasRegulations = createSelector(
    getDossier,
    (dossier) => {
        return dossier !== undefined &&
            dossier.territorialAreasRegulations !== undefined &&
            Object.keys(dossier.territorialAreasRegulations).length > 0 ?
            dossier.territorialAreasRegulations :
            undefined;
    }
);
/**
 * Is spatial dossier
 */
export const isSpatialDossier = createSelector(
    getDossier,
    (dossier) => {
        return dossier !== undefined &&
            dossier.summary !== undefined &&
            dossier.summary.spatialDossier;
    }
);
/**
 * Is regulations dossier
 */
export const isRegulationsDossier = createSelector(
    getDossier,
    (dossier) => {
        return dossier !== undefined &&
            dossier.summary !== undefined &&
            dossier.summary.regulationsDossier;
    }
);
/**
 * Get summary
 */
export const getSummary = createSelector(
    getDossier,
    (dossier) => {
        return dossier !== undefined &&
            dossier.summary !== undefined ?
            dossier.summary : undefined;
    }
);
